import { useState } from "react";
import "./UserCard.scss";
import { MenuInfo } from "rc-menu/lib/interface";
import { Button } from "../misc/Button";
import { Dropdown, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import Avatar from "./../Avatar";
import DateTimeStamp from "../misc/DateTimeStamp";
import {useRecoilState} from "recoil";
import {memberState} from "../../../state/atoms";

export interface AvailableSeatCardProps {
  date: string;
}

export default function AvailableSeatCard({ date }: AvailableSeatCardProps) {
  const [member] = useRecoilState(memberState);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const toggleDropdown = (info: MenuInfo) => {
    info.domEvent.stopPropagation();
    info.domEvent.preventDefault();
    switch (+info.key) {
      case 0:
        window.MHM.ProModal.addUser({memberId: member.id, flow: 'available-seat', onSuccess: () => window.location.reload()});
        return;
    }
  };

  const menu = (
    <Menu className={"is-primary-menu"} onClick={toggleDropdown}>
      <Menu.Item key="0">Invite New User</Menu.Item>
    </Menu>
  );

  return (
    <div className={"card user-card"}>
      <Dropdown
        placement="bottomRight"
        arrow
        visible={isDropdownVisible}
        className={"card-dropdown"}
        overlay={menu}
        trigger={["click"]}
        onVisibleChange={() => setIsDropdownVisible(!isDropdownVisible)}
      >
        <Button type={"Link"}>
          <EllipsisOutlined />
        </Button>
      </Dropdown>

      <div className={"circle"} />
      <Avatar />
      <h5>Available Seat</h5>
      {date && (
        <h5 className={"expiration-date"}>
          expires on <DateTimeStamp date={date} dateOnly />
        </h5>
      )}
    </div>
  );
}
